import React from "react";

import { StyledLink, WhatsAppIcon } from "./styles";

import WhatsAppSvg from "../../assets/svgs/whatsapp-svgrepo-com.svg";

const url = "https://api.whatsapp.com/send?phone=553135461200";
const ButtonWhatsApp = (): JSX.Element => (
  <StyledLink href={url} target="_blank">
    <WhatsAppIcon src={WhatsAppSvg} alt="WhatsApp" />
  </StyledLink>
);

export default ButtonWhatsApp;
